const article = {
  slug: 'move-out',
  title: 'Move-out and force move-out',
  section: 'Daily tasks',
  body: `
# Move-out

## Standard move-out

On the rental row choose **Move out**. The rental ends, the unit
returns to Available, and the tenant gets a final receipt. Collect any
balance first - the flow shows it.

## Force move-out (delinquent / abandoned)

**Force move-out** ends a rental that still carries a balance - for
cleanouts, abandonment, or after an auction. Open invoices are voided
and tagged as written off (per invoice, so each is reversible with
Unvoid and the amount stays reportable as bad debt), and the balance
zeroes. A tenant with a **credit** balance keeps it - the credit moves
to the customer for refund at close-out, never written off.

## Tenant-initiated move-out

By default tenants must **call the office** to give notice - the
move-out button in the tenant portal is off so you keep your
walk-through / cleanout-photo process. Facilities that want self-serve
notice can enable it per facility in Settings.
`,
};

export default article;
